import {StaticFilterProvider} from '@github-ui/filter-core/providers'
import {AiModelIcon, AppsIcon, CopilotIcon, PlayIcon, TagIcon} from '@primer/octicons-react'
import type {Category} from '../types'

function getListingTypeOptions(hideCopilotExtensions: boolean, hideGitHubModels: boolean) {
  const baseOptions = [
    {
      value: 'apps',
      description: 'Apps only',
      priority: hideCopilotExtensions ? 2 : 3,
      icon: AppsIcon,
      displayName: 'Apps',
    },
    {
      value: 'actions',
      description: 'Actions only',
      priority: hideCopilotExtensions ? 3 : 4,
      icon: PlayIcon,
      displayName: 'Actions',
    },
    // Add the Models option only when flag is OFF
    ...(hideGitHubModels
      ? []
      : [
          {
            value: 'models',
            description: 'Models only',
            priority: hideCopilotExtensions ? 1 : 2,
            icon: AiModelIcon,
            displayName: 'Models',
          },
        ]),
  ]
  if (!hideCopilotExtensions) {
    // Add the Copilot option only when flag is OFF
    return [
      {
        value: 'copilot',
        description: 'Copilot extensions only',
        priority: 1,
        icon: CopilotIcon,
        displayName: 'Copilot extensions',
      },
      ...baseOptions,
    ]
  }

  return baseOptions
}

export function getListingTypeFilterProvider(hideCopilotExtensions: boolean, hideGitHubModels: boolean) {
  return new StaticFilterProvider(
    {
      key: 'type',
      displayName: 'Listing type',
      icon: AppsIcon,
      priority: 1,
      description: 'Filter by listing type',
    },
    getListingTypeOptions(hideCopilotExtensions, hideGitHubModels),
    {
      filterTypes: {
        exclusive: false,
        multiValue: false,
        multiKey: false,
        valueless: false,
      },
    },
  )
}

/**
 * Creates a StaticFilterProvider for a given set of categories
 * @param categories The options to create the filter provider for
 */
export function createCategoryFilterProvider(categories: Category[]) {
  return new StaticFilterProvider(
    {
      key: 'category',
      displayName: 'Category',
      icon: TagIcon,
      priority: 1,
      description: 'Filter by category or tag',
      aliases: ['tag'],
    },
    categories.map((category, idx) => ({
      value: category.slug,
      displayName: category.name,
      priority: idx + 1,
    })),
    {
      filterTypes: {
        exclusive: false,
        multiKey: false,
        multiValue: false,
        valueless: false,
      },
    },
  )
}
